import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { useQuery } from 'react-query'
import { CliUsersResponse } from 'interfaces/cli-user'

interface GetCliUsersParams {
  page?: number
  searchQuery?: string
}

const fetchCliUsers = async (
  params: GetCliUsersParams = {}
): Promise<CliUsersResponse> => {
  const { page = 1, searchQuery } = params
  const urlParams = new URLSearchParams()

  urlParams.append('page', page.toString())
  urlParams.append('per_page', '25')

  if (searchQuery) {
    urlParams.append('query', searchQuery)
  }

  const response = await fetch(
    `${BASE_API_URL}/admin/api/v4/cli_users?${urlParams.toString()}`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  const handledResponse = handleErrors(response)
  return handledResponse.json()
}

const useGetCliUsers = (params: GetCliUsersParams = {}) => {
  return useQuery(['cli-users', params], () => fetchCliUsers(params), {
    refetchOnWindowFocus: false,
    staleTime: 60000,
    keepPreviousData: true,
  })
}

export default useGetCliUsers
